import React from 'react';
import { FaMapMarkedAlt, FaChartLine, FaBell, FaShieldAlt } from 'react-icons/fa';
import './VideoSection.css';

const VideoSection = () => {
  return (
    <section className="monitoring-section">
      <div className="monitoring-section-container">
        <div className="monitoring-content">
          {/* Conteúdo de Texto */}
          <div className="monitoring-text">
            <div className="section-badge">
              <FaShieldAlt /> Segurança e Controle
            </div>
            
            <h2 className="monitoring-title">
              Monitoramento Inteligente em Tempo Real
            </h2>
            
            <p className="monitoring-description">
              Tenha controle total da sua frota com nosso sistema avançado de rastreamento GPS. 
              Acompanhe a localização exata dos seus veículos, receba alertas instantâneos e 
              tome decisões estratégicas baseadas em dados precisos.
            </p>

            <div className="monitoring-benefits">
              <div className="benefit-box">
                <div className="benefit-icon-box">
                  <FaMapMarkedAlt />
                </div>
                <div className="benefit-content">
                  <h4>Rastreamento Preciso</h4>
                  <p>Localização exata em tempo real com atualização constante. GPS/GLONASS de alta precisão.</p>
                </div>
              </div>

              <div className="benefit-box">
                <div className="benefit-icon-box">
                  <FaChartLine />
                </div>
                <div className="benefit-content">
                  <h4>Relatórios Detalhados</h4>
                  <p>Histórico completo de rotas, paradas e velocidade. Análise de dados para otimizar operação.</p>
                </div>
              </div>

              <div className="benefit-box">
                <div className="benefit-icon-box">
                  <FaBell />
                </div>
                <div className="benefit-content">
                  <h4>Alertas Inteligentes</h4>
                  <p>Notificações instantâneas por SMS, email ou app. Geo-cerca e excesso de velocidade.</p>
                </div>
              </div>

              <div className="benefit-box">
                <div className="benefit-icon-box">
                  <FaShieldAlt />
                </div>
                <div className="benefit-content">
                  <h4>Segurança Total</h4>
                  <p>Proteção de dados com criptografia e backup automático. Sistema redundante confiável.</p>
                </div>
              </div>
            </div>

            {/* <div className="monitoring-stats">
              <div className="stat-item-small">
                <span className="stat-value">99.9%</span>
                <span className="stat-label">Disponibilidade</span>
              </div>
              <div className="stat-item-small">
                <span className="stat-value">24/7</span>
                <span className="stat-label">Suporte</span>
              </div>
              <div className="stat-item-small">
                <span className="stat-value">10s</span>
                <span className="stat-label">Atualização</span>
              </div>
            </div> */}
          </div>
        </div>
      </div>
    </section>
  );
};

export default VideoSection;

